import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';

document.addEventListener('DOMContentLoaded', () => {
	/* Initialise every instance separately, as the same slider can appear more than once on a page */
	for (const element of document.querySelectorAll('.swiper.infinite-slider')) {
		new Swiper(element, {
			modules: [Autoplay],
			slidesPerView: 'auto',
			spaceBetween: 64,
			loop: true,
			speed: 4000,
			allowTouchMove: false,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
		});
	}
});
